import { render, staticRenderFns } from "./SmsMin.vue?vue&type=template&id=30488f3f&"
import script from "./SmsMin.vue?vue&type=script&lang=js&"
export * from "./SmsMin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports